import { MainContent } from "../MainContent/mainContent";
import { Sidebar } from "../Sidebar"
import { AvisoInatividadeModal } from "../Sessao/AvisoInatividadeModal";

const PrivateLayout = () => {
  return (
    <>
      <div className=" grid min-h-screen p-2 gap-4 grid-cols-app bg-black text-zinc-50">
        <Sidebar />
        <MainContent />
      </div>
      <AvisoInatividadeModal />
    </>
  );
};

export default PrivateLayout;
